import { useCallback } from 'react'
import DialogButton from '../../Common/Buttons/DialogButton'
import Dialog from '../../Common/Dialog/Dialog'
import DialogActions from '../../Common/Dialog/DialogActions'
import DialogContent from '../../Common/Dialog/DialogContent'
import DialogTitle from '../../Common/Dialog/DialogTitle'
import { type UserProductDesignStore } from '../../UserData/_stores/UserProductDesignStore'
import { useTranslation } from 'react-i18next'
import { useAppDispatch } from '../../Common/_hooks/useAppDispatch'
import { BatchDeleteProductDesigns, type BatchProductDesignSelection } from '../../UserData/_actions/ProductDesignActions'
import { useAppSelector } from '../../Common/_hooks/useAppSelector'
import { ClearProductDesignSelectedProduct } from '../../UIData/_actions/Account/AccountStoreActions'

type Props = {
  opened: boolean
  onClose: () => void
} & ({
  productDesign: UserProductDesignStore
  selection?: never
  selectionCount?: never
} | {
  productDesign?: never
  selection: BatchProductDesignSelection
  selectionCount: number
})

export default function DeleteDesignDialog(props: Props) {
  const [t] = useTranslation('account-v2')
  const dispatch = useAppDispatch()
  const loader = useAppSelector(state => state.get('UIData').get('loaders').get('edit_product_designs'))

  const onConfirm = useCallback(() => {
    const selection = props.selection ?? {
      ids: [props.productDesign.get('id')],
    }

    dispatch(BatchDeleteProductDesigns(selection).set({
      onSuccess: () => {
        if (props.selection) {
          dispatch(ClearProductDesignSelectedProduct())
        }

        props.onClose()
      }
    }))
  }, [dispatch, props])

  return <Dialog
    open={props.opened}
    maxWidth="xs"
    fullWidth
    onClose={props.onClose}
    showCloseButton
  >
    <DialogTitle>{props.selection
      ? t('Delete {{count}} products', { count: props.selectionCount })
      : t('Delete {{name}}', { name: props.productDesign.get('name') })}</DialogTitle>
    <DialogContent>
      <p>{props.selection
        ? t('Are you sure that you want to delete the selected products?')
        : t('Are you sure that you want to delete this design?')}</p>
    </DialogContent>
    <DialogActions>
      <DialogButton
        color="secondary"
        disabled={!!loader}
        onClick={props.onClose}
      >{t('Cancel')}</DialogButton>
      <DialogButton
        color="error"
        onClick={onConfirm}
        disabled={!!loader}
        autoFocus
      >{t('Delete')}</DialogButton>
    </DialogActions>
  </Dialog>
}
